export default function Footer() {
    return <div className="py-5 bg-primary text-center text-white">&copy; KAMAL SOFTWARES 2025</div>
}
    